import { useEffect, useState } from 'react';
import { ScopeSwitcher } from '../components/ScopeSwitcher';
import { useScope } from '../lib/hooks';
import { purchasesApi } from '../lib/domain';
import { ApiError, OfflineError } from '../lib/api';

function errorMessage(err: unknown): string {
  if (err instanceof ApiError) return err.message;
  if (err instanceof OfflineError) return err.message;
  return 'Einkaufshistorie konnte nicht geladen werden.';
}

export function PurchasesPage() {
  const [scope] = useScope();
  const [purchases, setPurchases] = useState<Awaited<ReturnType<typeof purchasesApi.list>>['purchases']>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!scope) return;
    setLoading(true);
    setError(null);
    purchasesApi
      .list(scope)
      .then((r) => setPurchases(r.purchases))
      .catch((err) => setError(errorMessage(err)))
      .finally(() => setLoading(false));
  }, [scope]);

  return (
    <div className="stack">
      <h1>Einkaufshistorie</h1>
      <ScopeSwitcher />
      {error && (
        <p className="error-text" role="alert">
          {error}
        </p>
      )}
      {loading ? (
        <p>Lade…</p>
      ) : (
        <ul className="list-reset stack">
          {purchases.map((p) => (
            <li key={p.id} className="card row between">
              <div>
                <strong>{p.storeBranch ? `${p.storeBranch.chain.name} - ${p.storeBranch.name}` : 'Ohne Filiale'}</strong>
                <div className="muted">{new Date(p.purchasedAt).toLocaleString('de-DE')}</div>
              </div>
              <strong>{Number(p.totalAmount).toFixed(2)} €</strong>
            </li>
          ))}
          {purchases.length === 0 && !error && <p className="muted">Noch keine Einkäufe.</p>}
        </ul>
      )}
    </div>
  );
}
